import { Box, Button, Card, CardContent } from "@mui/material";
import { getCardAgreementLinks } from "../../common/TermsAndConditionsContentProvider";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { acceptCardAgreement } from "../../api/paymentMethodsService";
import { api } from "../../api/api";
import { useTranslation } from "react-i18next";

function CardAgreementPage() {
  const [searchParams] = useSearchParams();
  const callback = searchParams.get("callback");
  const action = searchParams.get("action");
  const hideAction = action === "hidden";
  const links = getCardAgreementLinks();
  const navigate = useNavigate();
  const [isAccepting, setIsAccepting] = useState(false);
  const { t } = useTranslation();

  const handleAccept = () => {
    setIsAccepting(true);
    api(acceptCardAgreement())
      .then(() => {
        const callbackPath = callback ? `/${callback}` : "/card-onboarding";
        navigate(callbackPath, { replace: true });
      })
      .catch((error) => {
        setIsAccepting(false);
      });
  };

  return (
    <Card
      variant="outlined"
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "calc(100vh - 56px - 32px)",
      }}
    >
      <CardContent
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          p: 0,
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <iframe
            src={links.content}
            style={{
              border: "none",
              flex: 1,
              width: "100%",
              overflowX: "hidden",
              overflowY: "auto",
            }}
          />
        </Box>
        {!hideAction && (
          <Box sx={{ px: 1 }}>
            <LoadingButton
              variant="contained"
              fullWidth
              onClick={handleAccept}
              loading={isAccepting}
            >
              {t("terms_accept")}
            </LoadingButton>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

export default CardAgreementPage;
